module.exports = __webpack_public_path__ + "img/城市燃气安全预警平台.aacece56.png";